import createIdbStorage from '@piotr-cz/redux-persist-idb-storage';

/** IndexedDB storage shared by redux-persist and pre-migration backups. */
export const projectPersistIdbStorage = createIdbStorage({ name: 'bps', storeName: 'keyval' });

/** redux-persist schema version for the project slice. Bump when migrate must run. */
export const PROJECT_PERSIST_VERSION = 2;
